import script from "./Barriers.vue?vue&type=script&setup=true&lang=js"
export * from "./Barriers.vue?vue&type=script&setup=true&lang=js"

import "./Barriers.vue?vue&type=style&index=0&id=7a929088&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a929088"]])

export default __exports__